import pageIndex from "@/views/recognize/page/pageIndex.vue";
export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: "pageIndex",
      name: "pageIndex",
      component: pageIndex,
    },

  ],
};
